import Header from './Header.vue';
import Content from './Content.vue';

export default {
    Header,
    Content,
};



// WEBPACK FOOTER //
// ./src/components/OrderList/index.js